export default {
  email: 'E-Mail-Adresse',
  password: 'Passwort'
}
